/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  connect,
} from 'react-redux';
import {
  injectIntl,
} from 'react-intl';


const propTypes = {
  id: React.PropTypes.string.isRequired,
  intl: React.PropTypes.object.isRequired,
};

class LocaleMsg extends React.Component {
  render() {
    const { id, intl } = this.props;
    return <span>{intl.formatMessage({ id, defaultMessage: id })}</span>;
  }
}

LocaleMsg.propTypes = propTypes;

export default connect(() => ({}), {})(injectIntl(LocaleMsg));




// WEBPACK FOOTER //
// ./src/components/LocaleMsg/index.jsx